var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('z-map-expandable',{attrs:{"destinations":_vm.destinations,"calculate-route":""},on:{"rate-change":_vm.rateChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }